<acep-master [env]="env" [inheritsso]="'false'" (logout)="logout()" #acepMaster>
    <div class="bodyCtr" slot="bodySlot">

        <div class="wrapper">
            <div class="content-wrapper">
                <div class="loader"></div>

                <div class="body-content">

                    <div class="container">
                        <h1 class="mt-sm">{{pageTitle}}</h1>
                    </div>

                    <app-navigation *ngIf="!hideNavigation"></app-navigation>
                    <router-outlet></router-outlet>

                    <link rel="stylesheet" type="text/css" [href]="csspath | safe">
                </div>
            </div>
        </div>

    </div>
</acep-master>